// @ts-nocheck
import React from 'react';

import AlertModal from 'components/shared/GlobalModalArea/Modal/AlertModal';

import { useDeleteDialog } from './functions';
import s from './index.module.css';
import { IDeleteDialogProps } from './types';

const DeleteDialog = ({ res, rej, ids }: IDeleteDialogProps) => {
  const { config } = useDeleteDialog({ rej, ids });
  const { headerText, bodyText, onAccept, closeButtonText, confirmButtonText } = config;

  return (
    <AlertModal
      res={res}
      headerText={headerText}
      bodyText={bodyText}
      onAccept={onAccept}
      closeButtonText={closeButtonText}
      confirmButtonText={confirmButtonText}
      footerClassName={s.modalButton}
    />
  );
};

export default DeleteDialog;
